/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { NEWS_ROUTE } from "../utils/consts";
import { fetchNews } from "../http/postAPI";
import { PostList } from "../components/Posts";

const NewsList = () => (
  <PostList
    title="Новости клиники"
    addLabel="новость"
    route={NEWS_ROUTE}
    fetchData={fetchNews}
  />
);
export default NewsList;
